// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__6h8Zt","themed":"styles_themed__sUMKe"};